import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Field, Form } from 'react-final-form';
import timezones from 'shared/timezones';
import Autocomplete from '../../autocomplete';
import Button from '../../button';
import FormError from '../../form-error';
import HelpText from '../../form-help-text';
import { Box, Flex, Grid } from '../../grid';
import Label from '../../label';
import { ClientFieldReference, FieldPrefixContext, HelpTextField, LabelField, NameField, PlaceholderField, PrivateField, RequiredField } from '../shared';
const Timezone = t0 => {
  const $ = _c(19);
  const {
    schema,
    disabled,
    menu,
    style,
    className,
    isCustom: t1
  } = t0;
  const isCustom = t1 === undefined ? false : t1;
  const prefix = React.useContext(FieldPrefixContext);
  const t2 = isCustom && "custom_fields";
  let t3;
  if ($[0] !== prefix || $[1] !== schema.name || $[2] !== t2) {
    t3 = [prefix, t2, schema.name].filter(_temp);
    $[0] = prefix;
    $[1] = schema.name;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const name = t3.join(".");
  let t4;
  if ($[4] !== schema.required) {
    t4 = value => {
      if (schema.required && !value) {
        return "Select a timezone";
      }
    };
    $[4] = schema.required;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== className || $[7] !== disabled || $[8] !== menu || $[9] !== schema.helptext || $[10] !== schema.label || $[11] !== schema.placeholder || $[12] !== schema.required || $[13] !== style) {
    t5 = t6 => {
      const {
        input,
        meta
      } = t6;
      return <Box style={style} className={className}><Flex mb={2} justifyContent="space-between"><Label sx={{
            flexGrow: 1
          }}>{schema.label}</Label>{menu}</Flex><Autocomplete {...input} tabIndex={disabled ? -1 : undefined} placeholder={schema.placeholder} sx={{
          display: "block",
          width: "100%"
        }} invalid={meta.touched && meta.error} itemToString={_temp2} items={timezones} isClearable={!schema.required} />{meta.error && meta.touched && <FormError>{meta.error}</FormError>}{schema.helptext && <HelpText>{schema.helptext}</HelpText>}</Box>;
    };
    $[6] = className;
    $[7] = disabled;
    $[8] = menu;
    $[9] = schema.helptext;
    $[10] = schema.label;
    $[11] = schema.placeholder;
    $[12] = schema.required;
    $[13] = style;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== name || $[16] !== t4 || $[17] !== t5) {
    t6 = <Field name={name} validate={t4}>{t5}</Field>;
    $[15] = name;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default Timezone;
export const toString = value => {
  return value || '';
};
export const View = t0 => {
  const $ = _c(2);
  const {
    value
  } = t0;
  const t1 = value || "";
  let t2;
  if ($[0] !== t1) {
    t2 = <Box>{t1}</Box>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export const Edit = t0 => {
  const $ = _c(12);
  const {
    isEditing,
    className,
    isUniqueFieldName,
    hideRequired,
    showClientFieldReference,
    value,
    menu,
    style
  } = t0;
  const [showMore, setShowMore] = React.useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setShowMore(_temp3);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleMore = t1;
  const removable = value.removable;
  let t2;
  if ($[1] !== className || $[2] !== hideRequired || $[3] !== isEditing || $[4] !== isUniqueFieldName || $[5] !== menu || $[6] !== removable || $[7] !== showClientFieldReference || $[8] !== showMore || $[9] !== style || $[10] !== value) {
    t2 = <>{!isEditing ? <Form onSubmit={_temp4}>{t3 => <Timezone schema={value} disabled={true} menu={menu} style={style} className={className} />}</Form> : <Grid sx={{
        display: !isEditing ? "none" : null
      }}><LabelField prefix="" />{!hideRequired && <RequiredField prefix="" />}<PlaceholderField prefix="" /><HelpTextField prefix="" />{showMore && <>{showClientFieldReference && removable && <PrivateField prefix="" />}<NameField prefix="" isUniqueFieldName={isUniqueFieldName} removable={removable} />{showClientFieldReference && removable && <ClientFieldReference prefix="" schema={value} />}</>}<Button onClick={toggleMore} size="small" width="100%" variant="outlined">{showMore ? "Show less ..." : "Show more ..."}</Button></Grid>}</>;
    $[1] = className;
    $[2] = hideRequired;
    $[3] = isEditing;
    $[4] = isUniqueFieldName;
    $[5] = menu;
    $[6] = removable;
    $[7] = showClientFieldReference;
    $[8] = showMore;
    $[9] = style;
    $[10] = value;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
function _temp(v) {
  return v;
}
function _temp2(v_0) {
  return v_0?.replace("_", " ");
}
function _temp3(v) {
  return !v;
}
function _temp4(value_0) {
  return null;
}